import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store";
import Toast from "./components/toast";

const checkPromptInput = () => {
  const storedValue = localStorage.getItem("userInputVYGA");
  if (!storedValue) {
    const userInput = prompt("Please enter password to proceed:");
    if (userInput === "Aa@123456") {
      localStorage.setItem("userInputVYGA", userInput);
    } else {
      alert("Invalid password. Please try again.");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      return false;
    }
  }
  return true;
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// if (checkPromptInput()) {
  root.render(
    <Provider store={store}>
      <Toast />
      <App />
    </Provider>
  );
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
